import { render, staticRenderFns } from "./EmailSmtp.vue?vue&type=template&id=2c191fde&"
import script from "./EmailSmtp.vue?vue&type=script&lang=js&"
export * from "./EmailSmtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c191fde')) {
      api.createRecord('2c191fde', component.options)
    } else {
      api.reload('2c191fde', component.options)
    }
    module.hot.accept("./EmailSmtp.vue?vue&type=template&id=2c191fde&", function () {
      api.rerender('2c191fde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/EmailSmtp.vue"
export default component.exports